import BlockType119Component from '@headlines/components/block/111-120/BlockType119.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType119: AdminBlockType = {
  component: BlockType119Component,
  attributes: AdminBlockTypeAttributes({}),
  articlesCount: 0,
};

export default AdminBlockType119;
